import type { RedditState } from './Reddit.types';

export const INIT_STATE: RedditState = {
  adAccounts: [],
  adAccountStatuses: {},
  authenticationUrl: '',
  loading: false,
};
